import { HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { baseURL } from 'config/config';
import { storage, KEYS } from 'Utils/storage';

/** Injects `Authorization: Bearer <token>` header on every HTTP request. */
export const authLink = setContext((_, { headers }) => {
    const token = storage.get(KEYS.TOKEN);
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    };
});

/** Points to the GraphQL HTTP endpoint. */
export const httpLink = new HttpLink({
    uri: baseURL + '/workfreeli',
});
